enum ReactQueryKeys {
  GET_AVAILABLE_LEAD_REVIEW = 'getAvailableLeadReview',
}

export { ReactQueryKeys };
